const pathArray = window.location.pathname.split('/');
const slug = pathArray[pathArray.length-2];

if(slug === 'drinking-never-drive') {

(function($){
    const state = {};
    const carouselItems = $('.can-banner');
    if(carouselItems.length > 0) {

    $('.carousel-prev').on('click', function() {
        $('.can-banner').each(function() {
            updatePos($(this), 1);
        })
    })

    $('.carousel-next').on('click', function() {
        $('.can-banner').each(function() {
            updatePos($(this), -1);
        })
    })

    const updatePos = function(element, increment = -1) {
        if(increment > 0 && parseInt(element.data('pos')) + increment > 2) {
            // element.dataset.pos = parseInt(element.dataset.pos) + increment - carouselItems.length;
            element.data('pos', parseInt(element.data('pos')) + increment - carouselItems.length);
        } else if (increment < 0 && parseInt(element.data('pos')) + increment < -3) {
            // element.dataset.pos = parseInt(element.dataset.pos) + increment + carouselItems.length;
            element.data('pos', parseInt(element.data('pos')) + increment + carouselItems.length);
        } else {
            // element.dataset.pos = parseInt(element.dataset.pos) + increment;
            element.data('pos', parseInt(element.data('pos')) + increment);
        }
        element.attr('data-pos', element.data('pos'));

        // Update Mobile Learn More button target on selected can
        if(parseInt(element.data('pos')) === 0) {
            mobileLearnMoreBtn.data('target', element.data('target')).attr('data-target', element.data('target'));
            $('.carousel-dot.active').removeClass('active');
            $('.carousel-dot[data-item-no="'+ element.data('item-no') +'"]').addClass('active');
        }
    };

    $('.can-banner').on('click', function(e) {
        if($(this).data('pos') == '0') {
            $($(this).data('target')).modal("show");
        }
    })

    $('.carousel-dot').on('click', function (e) {
        e.preventDefault();
        // console.log('.can-banner[data-item-no="'+ $(this).data('item-no') +'"]')
        var selectedCan = $('.can-banner[data-item-no="'+ $(this).data('item-no') +'"]');
        // console.log(selectedCan);
        var positionOffset = parseInt(selectedCan.data('pos'));
        console.log(parseInt(selectedCan.data('pos')));

        if(positionOffset != 0) {
            $('.can-banner').each(function() {
                updatePos($(this), positionOffset * -1)
            })
        }
    })

    $(".modal-drink-driving .transcriptData").click(function (e) {
        e.preventDefault();
        var parent_id = $(this).closest('.modal-drink-driving').attr('id');
        $("#" + parent_id + " .paragraph-text").fadeToggle("slow", function () {
            if ($(this).is(":visible")) {
                $("#" + parent_id + " .transcriptData").html('Hide transcript');
            } else {
                $("#" + parent_id + " .transcriptData").html('View transcript');
            }
        });

    });
    $('.modal-drink-driving .ytvideo .playbutton').on('click', function (e) {
        var parent_id = $(this).closest('.modal-drink-driving').attr('id');
        $("#" + parent_id + ' .ytvideo iframe').css("display", "block");
        $("#" + parent_id + ' .ytvideo .playbutton').css("display", "none");
        $("#" + parent_id + ' .ytvideo').css("background-image", "none");
        $("#" + parent_id + " .ytvideo iframe")[0].src += "?autoplay=1";
        e.preventDefault();
    });
    $('.modal-drink-driving').on('hidden.bs.modal', function () {
        var videos = document.querySelectorAll('iframe, video');
        Array.prototype.forEach.call(videos, function (video) {
            if (video.tagName.toLowerCase() === 'video') {
                video.pause();
            } else {
                var src = video.src;
                if (src.indexOf("autoplay=0") == 0) {
                    video.src = src.replace('autoplay=0', 'autoplay=1');
                } else {
                    video.src = src.replace('autoplay=1', 'autoplay=0');
                }
            }
        });
    })
}



})(jQuery)

}